"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/dropdown/style/css");

var _dropdown = _interopRequireDefault(require("antd/es/dropdown"));

require("antd/es/menu/style/css");

var _menu = _interopRequireDefault(require("antd/es/menu"));

require("antd/es/skeleton/style/css");

var _skeleton = _interopRequireDefault(require("antd/es/skeleton"));

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _messages = require("../../redux/messages/messages.types");

var _Util = require("../util/Util");

var _ThreadMembers = _interopRequireDefault(require("./ThreadMembers"));

var _ThreadOwnerBubbles = _interopRequireDefault(require("./ThreadOwnerBubbles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ThreadListItem extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      showMembers: false
    };

    this.renderTitle = title => {
      return title.length > 27 ? `${title.substring(0, 27)}...` : title;
    };

    this.renderLastMessageDate = date => {
      const fifteenMinutesAgo = (0, _moment.default)().subtract(15, 'minutes');
      return /*#__PURE__*/_react.default.createElement(_popover.default, {
        content: (0, _Util.renderDateWithTime)(date)
      }, (0, _moment.default)(date).calendar(undefined, {
        sameDay: now => {
          if ((0, _moment.default)(date).isAfter(fifteenMinutesAgo)) {
            if ((0, _moment.default)(date).isSame((0, _moment.default)(), 'minute')) {
              return '[Now]';
            }

            if ((0, _moment.default)().diff(date, 'seconds') > 60) {
              return `[${`${(0, _moment.default)().diff(date, 'minutes').toString()} min`}]`;
            }

            return '[< 1 min]';
          }

          return 'h:mm A';
        },
        lastDay: 'ddd',
        lastWeek: '[Last] ddd',
        sameElse: 'MMM Do'
      }));
    };

    this.handleClick = action => {
      const {
        archiveThread,
        unarchiveThread,
        thread,
        markImportant,
        unmarkImportant,
        markUnread,
        markRead
      } = this.props;

      switch (action) {
        case 'archive':
          archiveThread(thread.id);
          break;

        case 'unarchive':
          unarchiveThread(thread.id);
          break;

        case 'important':
          markImportant(thread.id);
          break;

        case 'unimportant':
          unmarkImportant(thread.id);
          break;

        case 'unread':
          markUnread(thread.id);
          break;

        case 'read':
          markRead(thread.id);
          break;

        case 'members':
          this.showMembers();
          break;
      }
    };

    this.handleAssignThread = async (assignUserIds, unassignUserIds) => {
      const {
        assignThread,
        unassignThread,
        thread
      } = this.props;
      const threadId = thread.id;
      await Promise.all(assignUserIds.map(id => assignThread({
        threadId,
        userId: id
      })));
      await Promise.all(unassignUserIds.map(id => unassignThread({
        threadId,
        userId: id
      })));
    };

    this.showMembers = () => {
      this.setState({
        showMembers: true
      });
    };

    this.closeMembers = () => {
      this.setState({
        showMembers: false
      });
    };
  }

  render() {
    const {
      thread,
      setActiveThread,
      activeThreadId
    } = this.props;
    const {
      showMembers
    } = this.state;
    const {
      participant
    } = thread;

    if (!participant) {
      return /*#__PURE__*/_react.default.createElement(_skeleton.default, {
        className: "thread-list-item",
        avatar: {
          size: 55
        },
        paragraph: {
          rows: 1,
          width: '90%'
        }
      });
    }

    const unread = thread.unreadMessageCount > 0 || thread.markedUnread;

    const menuOptions = /*#__PURE__*/_react.default.createElement(_menu.default, null, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "4",
      onClick: e => {
        this.handleClick('members');
      }
    }, /*#__PURE__*/_react.default.createElement("a", null, "Assign Members")), !thread.isImportant ? /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "2",
      onClick: e => this.handleClick('important')
    }, /*#__PURE__*/_react.default.createElement("a", null, "Mark as Important")) : /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "3",
      onClick: e => this.handleClick('unimportant')
    }, /*#__PURE__*/_react.default.createElement("a", null, "Mark as Not-Important")), unread ? /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "5",
      onClick: e => this.handleClick('read')
    }, /*#__PURE__*/_react.default.createElement("a", null, "Mark as Read")) : /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "5",
      onClick: e => this.handleClick('unread')
    }, /*#__PURE__*/_react.default.createElement("a", null, "Mark as Unread")), !thread.isArchived ? /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "0",
      onClick: e => this.handleClick('archive')
    }, /*#__PURE__*/_react.default.createElement("a", null, "Archive")) : /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "1",
      onClick: e => this.handleClick('unarchive')
    }, /*#__PURE__*/_react.default.createElement("a", null, "Mark as Active")));

    const activeClass = `thread-list-item ${activeThreadId === thread.id && 'thread-list-item-selected '}`;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: activeClass,
      onClick: e => {
        e.preventDefault();
        setActiveThread(thread.id);
      }
    }, showMembers && /*#__PURE__*/_react.default.createElement(_ThreadMembers.default, {
      members: thread.members,
      handleAssign: this.handleAssignThread,
      close: this.closeMembers,
      visible: showMembers
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-avatar-container"
    }, /*#__PURE__*/_react.default.createElement("i", {
      style: {
        visibility: thread.isImportant ? 'visible' : 'hidden'
      },
      className: "important fas fa-exclamation-circle fa-lg"
    }), /*#__PURE__*/_react.default.createElement("img", {
      className: "thread-avatar",
      alt: "avatar",
      src: `${participant.avatar ? participant.avatar.avatar : ''}`,
      style: {
        backgroundColor: participant.avatarBackground ? `#${participant.avatarBackground}` : '#FFB100'
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-item-content"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: ['thread-from', `${unread ? 'unread' : ''}`].join(' ')
    }, thread.participant.username), /*#__PURE__*/_react.default.createElement("span", {
      className: ['thread-title', `${unread ? 'unread' : ''}`].join(' ')
    }, this.renderTitle(thread.title)), /*#__PURE__*/_react.default.createElement("span", {
      className: ['thread-preview', 'one-line-fade', `${unread ? 'unread' : ''}`].join(' ')
    }, thread.preview), /*#__PURE__*/_react.default.createElement(_ThreadOwnerBubbles.default, {
      members: thread.members
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-item-info"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: ['thread-date', `${unread ? 'unread' : ''}`].join(' ')
    }, this.renderLastMessageDate(thread.lastMessageDate)), /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-item-options",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/_react.default.createElement(_dropdown.default, {
      overlay: menuOptions,
      trigger: ['click'],
      placement: "bottomRight"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-item-option-hitbox"
    }, /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement("i", {
      className: "far fa-ellipsis-v fa-lg"
    })))))));
  }

}

const mapDispatchToProps = dispatch => {
  return {
    archiveThread: threadId => dispatch(_messages.archiveThreadAsync.request(threadId)),
    unarchiveThread: threadId => dispatch(_messages.unarchiveThreadAsync.request(threadId)),
    markImportant: threadId => dispatch(_messages.markThreadImportantAsync.request(threadId)),
    unmarkImportant: threadId => dispatch(_messages.unmarkThreadImportantAsync.request(threadId)),
    assignThread: ({
      threadId,
      userId
    }) => dispatch(_messages.assignThreadAsync.request({
      threadId,
      userId
    })),
    unassignThread: ({
      threadId,
      userId
    }) => dispatch(_messages.unassignThreadAsync.request({
      threadId,
      userId
    })),
    markUnread: threadId => dispatch(_messages.markThreadUnreadAsync.request(threadId)),
    markRead: threadId => dispatch(_messages.markThreadReadAsync.request(threadId))
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ThreadListItem);

exports.default = _default;